import { render, staticRenderFns } from "./LsServiceRecOrReqDetails.vue?vue&type=template&id=29a8ad02&scoped=true&"
import script from "./LsServiceRecOrReqDetails.vue?vue&type=script&lang=js&"
export * from "./LsServiceRecOrReqDetails.vue?vue&type=script&lang=js&"
import style0 from "./LsServiceRecOrReqDetails.vue?vue&type=style&index=0&id=29a8ad02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a8ad02",
  null
  
)

export default component.exports